import { useContext } from 'react';
import { PluginContext } from 'ts-components/Plugins/context';
import { MarketPlacePluginApiName } from 'pages/Marketplace/types';
import { useBusinessAppConfig } from 'ts-components/Plugins/useBusinessAppConfig';

export const AI_FEATURE_CONFIG_KEYS = {
  chat: 'chat',
  automation_builder: 'automation_builder',
  automation_editor: 'automation_editor',
  form_builder: 'form_builder',
  survey_builder: 'survey_builder',
  custom_object_editor: 'custom_object_editor',
  email_builder: 'email_builder',
  filter_builder: 'filter_builder',
  llm_step_builder: 'llm_step_builder',
  code_step_builder: 'code_step_builder',
  homepage_builder: 'homepage_builder',
  dashboard_builder: 'dashboard_builder',
  chart_group_builder: 'chart_group_builder',
  dashlet_builder: 'dashlet_builder',
} as const;

export type AIFeatureConfigKey =
  (typeof AI_FEATURE_CONFIG_KEYS)[keyof typeof AI_FEATURE_CONFIG_KEYS];

export const useAIFeatures = (configKey?: AIFeatureConfigKey) => {
  const {
    installedPluginAPINamesToIds = {},
    isLoading: isContextLoading,
    isFetched,
  } = useContext(PluginContext);
  const { config, isLoading: isConfigLoading } = useBusinessAppConfig(
    MarketPlacePluginApiName.KizenAI
  );

  const pluginEnabled =
    MarketPlacePluginApiName.KizenAI in installedPluginAPINamesToIds;

  const featureEnabled =
    configKey && !isConfigLoading && !isContextLoading && isFetched
      ? config[configKey]?.value === true
      : false;

  return {
    aiFeaturesEnabled: pluginEnabled && featureEnabled,
  };
};
